import { DateTime } from "luxon";

export const formatDateTime = (
  value?: number | string | Date | null,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  if (!value) return "";

  const data = new Date(value);

  const opts: Intl.DateTimeFormatOptions = {
    // year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  };

  if (data.getFullYear() === currentYear) {
    delete opts.year;
  }

  let result = data.toLocaleString("ru-RU", opts);

  if (opts.month === "short") {
    result = result.replace(".", "");
  }

  return result;
};

export const formatTime = (value?: number | string | Date | null, options: Intl.DateTimeFormatOptions = {}): string => {
  if (!value) return "";

  return new Date(value).toLocaleString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  });
};

const currentYear = new Date().getFullYear();

export const formatDate = (value?: number | string | Date | null, options: Intl.DateTimeFormatOptions = {}): string => {
  if (!value) return "";

  const data = new Date(value);

  const opts: Intl.DateTimeFormatOptions = {
    // year: "numeric",
    month: "short",
    day: "2-digit",
    ...options,
  };

  if (data.getFullYear() === currentYear) {
    delete opts.year;
  }

  let result = data.toLocaleString("ru-RU", opts);

  if (opts.month === "short") {
    result = result.replace("марта", "мар").replace("февр.", "фев").replace(".", "");
  }

  return result;
};

export const formatMonth = (month?: number | string | undefined | null) => {
  if (month === undefined || month === null) return;
  return DateTime.local(2000, Number(month)).setLocale("ru").toLocaleString({ month: "long" });
};
